import { Route } from '@angular/router';
import { isAgencyGuard } from '@rma/dashboard/authentication/public/util-auth-redirect';
import { experienceVisibilityGuard } from '@rma/dashboard/layout/public/api-experience';
import { campaignsRoutes } from './campaigns.routes';
import { reviewRoutes } from './reviews.routes';

export const collectRoutes: Route[] = [
  {
    path: 'reviews',
    children: reviewRoutes,
  },
  {
    path: 'campaigns',
    children: campaignsRoutes,
  },
  {
    path: 'survey',
    canActivate: [isAgencyGuard(), experienceVisibilityGuard((s) => s.showNps$)],
    loadChildren: () => import('@rma/dashboard/survey/survey'),
  },
];
